export var Urls = {
    GetLookup: "lookup/GetLookup",
    GetTableMetaDatas: "lookup/GetTableMetadata",
    GetTableColumnMetaDatas: "lookup/GetTableColumnMetadata",
    GetLookupValues: "lookup/Get",
    UpdateLookupValues: "lookup/UpdateLookupValues",
    UpdateLookupsOrdering: "lookup/UpdateLookupsOrdering",
    ClearCache: "LookupCache/Cache",
};
export var LookupAdditionalData = {
    parentId: "parentId",
    isActive: "isActive",
    departmentId: "departmentId",
    isSelectable: "isSelectable",
    code: "code",
    isForAccept: "isForAccept",
    visibleForScopes: "visibleForScopes",
    scope: "scope"
};
export var GenesisLookups = {
    "branches": "branches",
    "departments": "departments",
    "roles": "roles",
    "users": "users",
    "workflowReasons": "workflowReasons",
    "confidentialityLevels": "confidentialityLevels"
};
export var CacheCategory = {
    lookups: "lookups"
};
